import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import RedeemVoucher from './redeem-voucher.vue';
import { hasPermission, hasAnyPermission, PermissionCode } from '@/common/js/constant/index.ts';
let Home = class Home extends Vue {
    get isZhCN() {
        return KLOOK.getLocale() === 'zh-CN';
    }
    get hasRedeemPermission() {
        return hasPermission(PermissionCode.Redeem);
    }
    get hasRedemptionAccess() {
        return hasAnyPermission(PermissionCode.Dashboard, PermissionCode.Redemption);
    }
    get hasFulfillmentPermission() {
        return hasPermission(PermissionCode.FulfillmentVoucher);
    }
};
Home = __decorate([
    Component({
        components: {
            RedeemVoucher,
        },
    })
], Home);
export default Home;
